import { AmplifyConfig, InterfaceConfig } from "@interfaces/response";
import { createTheme } from "@mui/material";

export const CustomTheme = createTheme({
  palette: {
    primary: {
      main: "#D45D00",
      dark: "#333F48",
      light: "#FFC72C",
    },
    secondary: {
      main: "#F2704F",
    },
    fontWeights: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    backgroundRight: {
      main: "#D45D00",
      dark: "#333F48",
      light: "#FFC72C",
      tab: "#FFF9E9",
    },
    phoneInput: {
      main: "#FEF5DD",
    },
    otherColors: {
      main: "#FFFFFF",
      backgroundsColors: "#333F48",
      tabText: "#FFFFFF",
      tabBackground: "#333F48",
      menuIcon: "#D45D00",
      alert_info_background: "#FFFBDD",
      alert_info_text: "#C99700",
      alert_info_icon: "#C99700",
      extra_light: "#FFF8E6",
      card_info_background_leasing: "#F7F7F7",
    },
    barProgress: {
      main: "#D45D00",
    },
    marketPlace: {
      main: "#FFFFFF",
      cardBackground: "#C2E5F3",
    },
    cotizador: {
      backgroundColor: "#FFF4D6",
      barColor: "#333F48",
      iconColor: "#D45D00",
      markLabelColor: "#333F48",
    },
    buttonSelected: {
      backgroundColor: "#D45D00",
      backgroundColorActive: "#333F48",
      textColor: "#333F48",
      textColorActive: "#FFFFFF",
      bordeColorActive: "#FFC72C",
    },
  },
  typography: {
    fontFamily: ["Outfit"].join(","),
    h1: {
      fontSize: 39,
      fontWeight: 300,
    },
    h2: {
      fontSize: 31,
      fontWeight: 300,
    },
    h3: {
      fontSize: 25,
      fontWeight: 300,
    },
    h4: {
      fontSize: 20,
      fontWeight: 300,
    },
    h5: {
      fontSize: 16,
      fontWeight: 300,
    },
    body1: {
      fontSize: 16,
      fontWeight: 300,
    },
    body2: {
      fontSize: 13,
      fontWeight: 300,
    },
    body3: {
      fontSize: 11,
      fontWeight: 300,
      fontFamily: "Outfit",
    },
  },
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#FFC72C",
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "#FFC72C",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
          },
          "& .MuiFilledInput-root": {
            borderRadius: "10px",
          },
          "& .MuiInputBase-root": {
            borderRadius: "10px",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#FFC72C",
          },
          "& .MuiInput-underline::before": {
            borderColor: "#FFC72C",
          },
          "& .MuiFilledInput-underline::before": {
            borderColor: "#FFC72C",
          },
          "& .MuiInputLabel-asterisk": {
            color: "#CD0202",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          padding: "10px 25px",
          textTransform: "none",
          fontSize: 16,
          fontWeight: 700,
        },
      },
      variants: [
        {
          props: {
            variant: "default",
          },
          style: {
            backgroundColor: "#D45D00",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#D45D00",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#333F48",
              color: "#FFC72C",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
        {
          props: {
            variant: "default_disabled",
          },
          style: {
            backgroundColor: "#D45D00",
            opacity: 0.4,
            color: "#FFF",
            // "&.Mui-disabled": {
            //   backgroundColor: "#528CD6",
            //   opacity: 0.4,
            //   color: "#FFF",
            // },
            "&:hover": {
              backgroundColor: "#D45D00",
              color: "#FFF",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },

        {
          props: {
            variant: "contained",
          },
          style: {
            "&.Mui-disabled": {
              backgroundColor: "#D45D00",
              opacity: 0.4,
              color: "#FFF",
            },
          },
        },
        {
          props: {
            variant: "orange",
          },
          style: {
            backgroundColor: "#F2704F",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#F2704F",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#F2704F",
            },
          },
        },
        {
          props: {
            variant: "black",
          },
          style: {
            backgroundColor: "#2C2C2C",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#2C2C2C",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#2C2C2C",
            },
          },
        },
        {
          props: {
            variant: "blue_outlined",
          },
          style: {
            color: "#333F48",
            backgroundColor: "#FFF",
            border: "2px solid #333F48",
            lineHeight: "22px",
            "&.Mui-disabled": {
              color: "#bdbdbd",
              border: "2px solid #bdbdbd",
              backgroundColor: "transparent",
            },
            "&.MuiButton-blue_outlinedSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
        {
          props: {
            variant: "blue_demon",
          },
          style: {
            // color: "#FFC72C",
            color: "#FFFFFF",
            backgroundColor: "#333F48",
            "&.Mui-disabled": {
              color: "#FFFFFF",
              backgroundColor: "#333F48",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#333F48",
            },
          },
        },
        {
          props: {
            variant: "green",
          },
          style: {
            color: "#FFFFFF",
            backgroundColor: "#00BB2D",
            "&.Mui-disabled": {
              backgroundColor: "#009A24",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#009A24",
            },
          },
        },
        {
          props: {
            variant: "expediente_validado",
          },
          style: {
            width: "150px",
            height: "30px",
            fontSize: 15,
            color: "#D45D00",
            backgroundColor: "#FFC72C",
            "&.Mui-disabled": {
              backgroundColor: "#FFC72C",
              opacity: 0.4,
            },
            "&:hover": {
              backgroundColor: "#FFC72C",
            },
          },
        },
        {
          props: {
            variant: "expediente_validado",
            size: "small",
          },
          style: {
            width: "90px",
            height: "23px",
            fontSize: 13,
          },
        },
        {
          props: {
            variant: "expediente",
          },
          style: {
            paddingLeft: "10px",
            paddingRight: "10px",
            width: "150px",
            height: "30px",
            fontSize: 15,
            backgroundColor: "#D45D00",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#D45D00",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#333F48",
              color: "#FFC72C",
            },
          },
        },
        {
          props: {
            variant: "expediente",
            size: "small",
          },
          style: {
            width: "90px",
            height: "23px",
            fontSize: 13,
          },
        },
        {
          props: {
            variant: "yellow",
          },
          style: {
            backgroundColor: "#FF9D14",
            color: "#FFF",
            "&.Mui-disabled": {
              backgroundColor: "#FF9D14",
              opacity: 0.4,
              color: "#FFF",
            },
            "&:hover": {
              backgroundColor: "#FF9D14",
              color: "#FFF",
            },
            "&.MuiButton-defaultSizeSmall": {
              fontSize: 11,
              fontWeight: 600,
              padding: "2px 8px",
            },
          },
        },
      ],
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: "#FF6060",
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          "& .MuiInputLabel-asterisk": {
            color: "#CD0202",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#FFC72C", // Borde azul cuando no está enfocado
              borderRadius: "5px",
            },
            "&:hover fieldset": {
              borderColor: "#FFC72C", // Borde azul al pasar el cursor
            },
            "&.Mui-focused fieldset": {
              borderColor: "#FFC72C", // Borde azul cuando está enfocado
            },
          },
          "& .MuiSelect-icon": {
            color: "#FFC72C", // Color del icono de selección
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          // "& .MuiSelect-icon": {
          //   color: "#FFC72C",
          // },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#FFC72C",
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: "14px",
          boxShadow: "8px 4px 20px 0px rgba(82, 140, 214, 0.25)",
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          // backgroundColor: "rgba(0, 0, 0, 0.5)",
          // border: "2px red solid"
          // ".aria-labelledby": {
          //   border: "2px blue solid"
          // }
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        determinate: {
          color: "#FFC72C",
        },
        indeterminate: {
          color: "#D45D00",
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          color: "#333F48",
        },
      },
    },
  },
});

export const interfaceConfig: InterfaceConfig = {
  name: "finbe",
  home_url: import.meta.env.VITE_URL_HOME_FINBE,
  aviso_privacidad: import.meta.env.VITE_URL_HOME_FINBE + "/aviso-de-privacidad",
  terminos_condiciones: import.meta.env.VITE_URL_HOME_FINBE + "/terminos-y-condiciones",
  terminos_condiciones_empresa: import.meta.env.VITE_URL_HOME_FINBE + "/terminos-y-condiciones-credito-empresarial",
  interest_rate: 30,
  metadata: {
    title: "Soluciones financieras para crecer tu negocio",
    description: "Solicita en minutos un crédito simple y sin garantía",
    favicon: "finbe/portal/logos/favicon.ico",
    ogImage: "https://develop.d1yqxqednb1e91.amplifyapp.com/opengraph-image.jpg?c044d823f8594106",
  },
  navbar: {
    logo: "finbe/portal/logos/logo_dark.png",
    logo_width: 142,
    logo_height: 32,
  },
  lateral: {
    logo_light: "finbe/portal/logos/logo_light_bg.png",
    bg_light: CustomTheme.palette.primary.light,
    text_light: CustomTheme.palette.primary.dark,
    logo_dark: "finbe/portal/logos/logo_dark_bg.png",
    bg_dark: CustomTheme.palette.primary.dark,
    text_dark: "#FFFFFF",
    image_list: [
      "finbe/portal/lateral/imagen_1.webp",
      "finbe/portal/lateral/imagen_2.webp",
      "finbe/portal/lateral/imagen_3.webp",
      "finbe/portal/lateral/imagen_4.webp",
      "finbe/portal/lateral/imagen_5.webp",
      "finbe/portal/lateral/imagen_6.webp",
      "finbe/portal/lateral/imagen_7.webp",
      "finbe/portal/lateral/imagen_8.webp",
      "finbe/portal/lateral/imagen_9.webp",
      "finbe/portal/lateral/imagen_10.webp",
    ],
    text_list: [
      "Tu empresa merece soluciones a su medida",
      "Impulsa tu negocio con el respaldo que necesitas",
      "Haz realidad tus planes de crecimiento",
      "El futuro de tu empresa comienza hoy",
      "Aquí, el siguiente paso lo das tú",
      "Solidez y confianza para avanzar juntos",
      "Más oportunidades para el desarrollo de tu empresa",
      "Decide, avanza y haz crecer tu negocio",
      "Soluciones simples para empresas que quieren más",
      "Construye tu historia de éxito con FinBe",
    ],
  },
  textos_tofu: {
    pm: {
      crear_cuenta: {
        titulo: "Te damos la bienvenida",
        sub_titulo: "",
      },
      registro_datos_personales: {
        titulo: "Creación de cuenta",
        sub_titulo: "",
      },
      validacion_telefono: {
        titulo: "Validación de teléfono",
        sub_titulo: "",
      },
      datos_empresa_pm: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      consulta_ciec: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      uso_de_credito: {
        titulo: "Selección de uso de crédito",
        sub_titulo: "",
      },
      presencia_digital_pm: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
      datos_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      rfc_curp: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      domicilio_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      consulta_buro_nip: {
        titulo: "Validación para consulta buró",
        sub_titulo: "",
      },
      buro_bloqueado: {
        titulo: "Consulta de Buró de Crédito del Accionista Bloqueada",
        sub_titulo: "",
      },
    },

    pfae: {
      datos_empresa_pfae: {
        titulo: "Registro de empresa",
        sub_titulo: "Ingresa los datos de la persona física con actividad empresarial",
      },
      consulta_buro_pfae: {
        titulo: "Consulta Buró",
        sub_titulo: "",
      },
      domicilio_pfae: {
        titulo: "Domicilio",
        sub_titulo: "",
      },
      presencia_digital_pfae: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
    },
  },
  maps: {
    api_key:
      import.meta.env.VITE_ENV === "PROD"
        ? "AIzaSyAiV-uuz8-emZFpk28KuxPiy95Y_yKZIp0"
        : "AIzaSyAPkyPkzcAbvKAageB8UN25PKbzl4stiWc",
  },
  companyNames: [
    "Financiera Bepensa SA DE CV SOFOM ER",
    "Bepensa Leasing SA DE CV",
    "AB&C Leasing de México SAPI DE CV",
    "Lendit Group SAPI de CV",
  ],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
  firma: {
    video_url:
      import.meta.env.VITE_ENV === "PROD"
        ? "https://static-resource.lendia.mx/finbe/portal/media/customer_welcome-signature.mp4"
        : "https://static-resource.lenditgroup.com/finbe/portal/media/customer_welcome-signature.mp4",
    provider: "legalario",
    legalario_config: {
      custom_url_sdk: import.meta.env.VITE_ENV === "PROD" ? "https://sdk.legalario.com/finBe/sdk-dist.js" : "",
      organization_id: import.meta.env.VITE_ENV === "PROD" ? "6834e22990aa7213b84e5522" : "680fb72a3750460f1c548673",
      api_key:
        import.meta.env.VITE_ENV === "PROD"
          ? "7f9c2ba4e88f827d616045507605853ed73b8093a03f8aa2b7e0e2c78c1e6025"
          : "f65d302d4fbdd71f13fd629e0b67a8971afa1f72cc931bc55f6c6e1f2094fdab",
    },
    condiciones_credito: {
      monto: true,
      plazo: true,
      tasa: false,
    },
    habilitar_calendario_pagos: true,
    habilitar_tabla_amortizacion: true,
  },
  scripts: {
    tag_id_google: "G-GRSNLB3TYW",
    tag_id_linkedin: "6355068",
    tag_id_hotjar: "6412809",
    tag_id_meta_pixel: "1135735424251241",
  },
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_YWntpKnYk",
      userPoolClientId: "4qiq9837g21na4jrpnm6s6rokd",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_6Kcxh4l1m",
      userPoolClientId: "5fveuoevde7c8f7scm3dbm5j63",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
